import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { EmployeeService } from '../../layout/dashboard/components/services/employee.service';
declare var $: any;
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
    public menuItems: any[] = [];
    public isToogle: boolean = false;
    public activeRoute: string = '';
    public static isOpenSideBar = new EventEmitter();
    public currentPharmacy: any = {};
    public newVersion: any;
    public userRole: string = '';
    public userId: number = 0;
    public hasTablePermission: boolean = false;
constructor(
        private router: Router,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private authService: EmployeeService
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.activeRoute = event.url;
            this.setActiveMenuItem();
        });
    }
ngOnInit() {
        this.userRole = this.authService.getUserRole();
        this.userId = this.authService.getUserId();
        this.hasTablePermission = this.authService.hasCreateTablePermission(); this.filterMenuByRole(); $.getScript('assets/js/app-sidebar.js');
        this.activeRoute = this.router.url;
        setTimeout(() => {
            this.setActiveMenuItem();
        });
    }
    filterMenuByRole() {
        const allMenuItems = ROUTES.filter(menuItem => menuItem); if (this.userRole === 'owner') {
            this.menuItems = allMenuItems;
        } else if (this.userRole === 'employee') {
            this.menuItems = allMenuItems.filter(item =>
                item.title === 'Data' || item.title === 'Employee'
            );
        } else {
            if (!this.hasTablePermission) {
                this.menuItems = allMenuItems.filter(item =>
                    item.title !== 'Table'
                );
            } else {
                this.menuItems = allMenuItems;
            }
        }
    }
setActiveMenuItem() {
        if (!this.menuItems || this.menuItems.length === 0) {
            return;
        }
        this.menuItems.forEach(item => {
            item.isActive = false;
            if (item.submenu && item.submenu.length > 0) {
                item.submenu.forEach((subItem: any) => {
                    subItem.isActive = false;
                });
            }
        });
        const isDashboard = this.activeRoute === '/dashboard' || this.activeRoute === 'dashboard';
        if (isDashboard) {
            const defaultMenu = this.menuItems.find(item => item.path === 'master-data' || item.title === 'Table');
            if (defaultMenu) {
                defaultMenu.isActive = true;
                return;
            } else if (this.menuItems.length > 0) {
this.menuItems[0].isActive = true;
                return;
            }
        }
        let foundActive = false;
        for (const item of this.menuItems) {
            const itemPath = item.path;
            const normalizedItemPath = itemPath.startsWith('/') ? itemPath : '/' + itemPath;
            if (this.activeRoute === normalizedItemPath ||
                this.activeRoute.startsWith(normalizedItemPath + '/')) {
                item.isActive = true;
                foundActive = true;
                if (item.submenu && item.submenu.length > 0) {
                    for (const subItem of item.submenu) {
                        const subItemPath = itemPath + '/' + subItem.path;
                        const normalizedSubPath = subItemPath.startsWith('/') ? subItemPath : '/' + subItemPath; if (this.activeRoute === normalizedSubPath ||
                            this.activeRoute.startsWith(normalizedSubPath + '/')) {
                            subItem.isActive = true;
                        }
                    }
                }
                break;
            }
        }
        if (!foundActive) {
            const urlSegments = this.activeRoute.split('/').filter(segment => segment);
            if (urlSegments.length > 0) {
                const firstSegment = urlSegments[0];
                for (const item of this.menuItems) {
                    const itemSegments = item.path.split('/').filter((segment: any) => segment);
                    if (itemSegments.length > 0 && itemSegments[0] === firstSegment) {
                        item.isActive = true;
                        break;
                    }
                }
            }
        }
    }
navigateToRoute(path: string) {
        if (path.startsWith('/')) {
            path = path.substring(1);
        }
        const pathParts = path.split('/'); if (pathParts.length === 1) {
            this.router.navigate(['/', path]);
        } else {
            const segments = pathParts.filter(part => part.trim() !== '');
            this.router.navigate(segments);
        }
    }
toggleSidebar() {
        this.isToogle = !this.isToogle;
        SidebarComponent.isOpenSideBar.emit(this.isToogle);
    }
}